import React from 'react'
import { Box, Alert } from '@mui/material'
import theme from '../theme'

export interface AlertContents {
  open: boolean
  message: string
  severity: 'success' | 'error' | 'info' | 'warning'
}

interface Props {
  alert: AlertContents
  onClose: () => void
  backgroundColor?: string
}

const AlertMessage = ({
  alert,
  onClose,
  backgroundColor = theme.palette['base-white']
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        padding: '0 100px',
        backgroundColor: backgroundColor
      }}
    >
      <Alert
        severity={alert?.severity}
        onClose={onClose}
        sx={{
          width: 'fit-content',
          borderRadius: theme.borders['rounded-10']
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: alert?.message }} />
      </Alert>
    </Box>
  )
}

export default AlertMessage
